<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <router-view :class="Loading ? 'disable' : ''"></router-view>
              <div v-if="Loading === true">
                <div class="centered-spinner">
                  <a-spin />
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>
    <Modal />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/admin/AdminSidebar.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "Payment",
  data() {
    return {};
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
    Modal,
  },
  computed: {
    Loading() {
      return this.$store.state.payment.Loading;
    },
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "prefunding",
        activeMenu: this.activeMenu ? this.activeMenu : "1TimePayment",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
</style>
